export default {
  name: "CatalogueView",
  props: {
    vm: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "vm.is_dropin_selected": {
      immediate: true,
      handler(isDropInSelected) {
        if (this.vm && isDropInSelected) {
          this.$nextTick(this.initAddItemLocationAutocomplete);
        }
      },
    },
  },
  mounted() {
    this.addItemModal = this.$refs.addItemModal;

    if (this.addItemModal) {
      this.addItemModal.addEventListener("shown.bs.modal", this.handleAddItemModalShown);
    }
  },
  beforeUnmount() {
    if (this.addItemModal) {
      this.addItemModal.removeEventListener("shown.bs.modal", this.handleAddItemModalShown);
    }
  },
  methods: {
    handleAddItemModalShown() {
      if (!this.vm) return;
      this.vm.fetch_categories();
      this.initAddItemLocationAutocomplete();
    },
    initAddItemLocationAutocomplete() {
      const locationInput = this.$refs.addItemLocationInput;

      if (!this.vm?.is_dropin_selected || !locationInput) {
        return;
      }

      this.vm.get_autocomplete_location(locationInput, (address) => {
        this.vm.item_form.service_location = address;
        if (this.vm.errors) {
          this.vm.errors.service_location = null;
        }
      });
    },
    resetProductForm() {
      if (!this.vm) return;
      this.vm.reset_product_form();
      this.resetFileInputs();
    },
    resetFileInputs() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
      if (this.$refs.editFileInput) {
        this.$refs.editFileInput.value = null;
      }
    },
    clickFileInput() {
      this.$refs.fileInput?.click();
    },
    clickEditFileInput() {
      this.$refs.editFileInput?.click();
    },
  },
};

function append_if_present(form_data, key, value) {
  if (value !== undefined && value !== null && value !== "") {
    form_data.append(key, value);
  }
}

function append_media_files(form_data, files = []) {
  files.forEach((file) => {
    form_data.append("media_files", file);
  });
}

function build_create_item_form_data({
  item_form,
  base_profile_id,
  product_type_id,
  selected_subcategory,
  upload_files,
}) {
  const form_data = new FormData();

  form_data.append("name", item_form.name);
  form_data.append("price", item_form.price);
  form_data.append("description", item_form.description || "");
  form_data.append("base_profile", base_profile_id);
  form_data.append("product_type_id", product_type_id);
  form_data.append("category_id", selected_subcategory || "");
  form_data.append("attributes", JSON.stringify(item_form.attributes || {}));

  append_if_present(form_data, "service_type_id", item_form.service_type_id);
  append_if_present(form_data, "location", item_form.service_location);
  append_media_files(form_data, upload_files);

  return form_data;
}

function build_update_item_form_data({
  update_item_form,
  base_profile_id,
  upload_files,
  previews,
}) {
  const form_data = new FormData();

  form_data.append("product_id", update_item_form.product_id);
  form_data.append("name", update_item_form.name);
  form_data.append("price", update_item_form.price);
  form_data.append("description", update_item_form.description || "");
  form_data.append("base_profile_id", base_profile_id);
  form_data.append("category_id", update_item_form.subcategory_id || "");
  form_data.append("attributes", JSON.stringify(update_item_form.attributes || {}));

  append_if_present(form_data, "service_type_id", update_item_form.service_type_id);
  append_if_present(form_data, "location", update_item_form.location);
  append_media_files(form_data, upload_files);

  previews
    .filter((preview) => preview._delete && preview.id)
    .map((preview) => preview.id)
    .forEach((id) => form_data.append("delete_image_ids", id));

  return form_data;
}

function submit_catalogue_item({ endpoint, form_data, token }) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/${endpoint}/`,
      method: "POST",
      headers: {
        Authorization: `Token ${token}`,
      },
      data: form_data,
      processData: false,
      contentType: false,
      success: resolve,
      error: reject,
    });
  });
}

export function create_catalogue_item(options) {
  const form_data = build_create_item_form_data(options);

  return submit_catalogue_item({
    endpoint: "create_product",
    form_data,
    token: options.token,
  });
}

export function update_catalogue_item(options) {
  const form_data = build_update_item_form_data(options);

  return submit_catalogue_item({
    endpoint: "update_product",
    form_data,
    token: options.token,
  });
}
